import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="public-light bg-[#050505] min-h-screen text-[#F5F2EB]">
      <Navbar/>
      <main className="max-w-3xl mx-auto px-6 pt-32 pb-20">
        <div className="text-[10px] tracking-[0.32em] uppercase text-[#DC2626] font-medium">Legal</div>
        <h1 className="font-serif text-4xl md:text-5xl mt-3 text-[#18181b] leading-tight">Terms &amp; Conditions</h1>
        <p className="text-xs text-[#71717a] mt-3">Last updated: February 17, 2026</p>

        <div className="prose prose-sm max-w-none mt-10 space-y-6 text-[#3f3f46]">

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">1. Program Overview</h2>
            <p>The Delux Limo Trans Group LLC SMS messaging program ("Program") delivers transactional notifications related to your limousine reservations. By providing your mobile number during booking on <a href="https://deluxlimotransgroup.com" className="text-[#DC2626] underline">deluxlimotransgroup.com</a>, you agree to receive recurring automated SMS messages from us at that number.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">2. Message Frequency</h2>
            <p>Message frequency varies based on your reservation activity. A typical trip generates 3–7 messages: booking confirmation, driver assignment, en-route notice, arrival notice, and post-trip thank you. Reminder messages are sent 2 hours and 1 hour before pickup.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">3. Message and Data Rates</h2>
            <p><strong>Message and data rates may apply.</strong> Standard messaging rates from your wireless carrier apply to all messages sent and received under the Program. Delux Limo Trans Group LLC is not responsible for any charges from your wireless carrier.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">4. Opt-Out Instructions</h2>
            <p>You may opt out of the Program at any time by replying <strong>STOP</strong> to any message we send you. After opting out, you will receive one final confirmation message confirming that you have been unsubscribed. No further messages will be sent unless you opt back in.</p>
            <p>To opt back in, reply <strong>START</strong> to any message from us, or book a new reservation with your phone number.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">5. Help Instructions</h2>
            <p>For help or more information, reply <strong>HELP</strong> to any message we send you, call us at <a href="tel:+14143336275" className="text-[#DC2626]">(414) 333-6275</a>, or email <a href="mailto:reservations@deluxlimotransgroup.com" className="text-[#DC2626]">reservations@deluxlimotransgroup.com</a>.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">6. Supported Carriers</h2>
            <p>The Program supports most major U.S. carriers including AT&amp;T, Verizon, T-Mobile, Sprint, MetroPCS, U.S. Cellular, Cricket, Boost, Virgin Mobile, and others. Carriers are not liable for delayed or undelivered messages.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">7. Cancellation &amp; Refunds</h2>
            <p>Reservation cancellations must be made at least 4 hours before scheduled pickup to avoid cancellation fees. Specific cancellation terms are disclosed at the time of booking.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">8. Service Limitations</h2>
            <p>Delux Limo Trans Group LLC reserves the right to refuse service, change pricing, modify vehicle availability, or terminate this Program at any time without prior notice. We are not liable for delays caused by traffic, weather, mechanical failure, flight delays, or other events outside our control, though we will use commercially reasonable efforts to mitigate them.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">9. Privacy</h2>
            <p>Your information is handled in accordance with our <a href="/privacy" className="text-[#DC2626] underline">Privacy Policy</a>. We do not sell or share your personal information with third parties for marketing purposes.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">10. Governing Law</h2>
            <p>These Terms are governed by the laws of the State of Wisconsin, United States. Any disputes will be resolved in Milwaukee County, Wisconsin courts.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">11. Contact</h2>
            <address className="not-italic">
              <strong>Delux Limo Trans Group LLC</strong><br/>
              Milwaukee, Wisconsin, United States<br/>
              Phone: <a href="tel:+14143336275" className="text-[#DC2626]">(414) 333-6275</a><br/>
              Email: <a href="mailto:reservations@deluxlimotransgroup.com" className="text-[#DC2626]">reservations@deluxlimotransgroup.com</a><br/>
              Web: <a href="https://deluxlimotransgroup.com" className="text-[#DC2626] underline">deluxlimotransgroup.com</a>
            </address>
          </section>
        </div>
      </main>
      <Footer/>
    </div>
  );
}
